import { FC } from 'react';
import { Link } from 'react-router-dom';

import TextButton from '@/components/elements/Button/TextButton';
import NewsIndexList from '@/components/layouts/News/IndexList';
import NewsIndexListSkeleton from '@/components/layouts/News/IndexList/Skeleton';
import { useUserContext } from '@/contexts/user';
import { EntryCampaign } from '@/lib/microcms/model';
import { NewsType } from '@/pages/News/types';

import { Headline } from '../style';
import {
  ButtonWrapper,
  Container,
  ContentEmptyMessage,
  ContentList,
} from './style';
import { Campaigns } from './types';

interface CurrentCampaignTemplateProps {
  campaigns: Campaigns;
  enteringCampaignIds: EntryCampaign['id'][];
  loading: boolean;
}

const CurrentCampaignTemplate: FC<CurrentCampaignTemplateProps> = ({
  campaigns,
  enteringCampaignIds,
  loading,
}) => {
  const { isMember } = useUserContext();

  return (
    <Container>
      <Headline>実施中のキャンペーン</Headline>
      {(Object.keys(campaigns) as (keyof Campaigns)[]).map(type => (
        <ContentList key={type}>
          <h2>{type === 'entries' ? 'エントリー' : 'その他'}キャンペーン</h2>
          {campaigns[type].length ? (
            <NewsIndexList
              type={NewsType.Campaign}
              contentsList={campaigns[type]}
              enteringCampaignIds={enteringCampaignIds}
              visibleEntryStatus={isMember && type === 'entries'}
              visiblePublishedAt={false}
            />
          ) : (
            <>
              {loading ? (
                <NewsIndexListSkeleton
                  type={NewsType.Campaign}
                  count={5}
                  visiblePublishedAt={false}
                />
              ) : (
                <ContentEmptyMessage>
                  {type === 'entries' ? (
                    <>
                      現在エントリーが可能なキャンペーンは
                      <br />
                      ありません
                    </>
                  ) : (
                    <>実施中のキャンペーンはありません</>
                  )}
                </ContentEmptyMessage>
              )}
            </>
          )}
        </ContentList>
      ))}
      <ButtonWrapper>
        <Link to="/campaign">
          <TextButton size="s" hoverEffect="highlight">
            キャンペーン一覧を見る
          </TextButton>
        </Link>
      </ButtonWrapper>
    </Container>
  );
};

export default CurrentCampaignTemplate;
